<script setup lang="ts">
import { assert } from '~~/src/layers/toolkit/toolkit';

defineSlots<{ default: () => void }>();

const DEFAULT_ITEM_COUNT = 40;
const DEFAULT_GAP = '96px';

const itemCount = ref(DEFAULT_ITEM_COUNT);
const itemRefs = useTemplateRef('item_refs');
onMounted(setItemCount);
useEventListener('resize', setItemCount);

function setItemCount() {
  if (itemRefs.value) {
    itemCount.value = optimizeItemCount(itemRefs.value);
  }
}

function optimizeItemCount(elements: HTMLElement[]) {
  const element = elements[0];
  assert(element, 'At least one element must always be present');
  const widthScreen = window.innerWidth;
  const widthElement = element.getBoundingClientRect().width;
  const itemsToFillScreen = Math.ceil(widthScreen / widthElement);
  return itemsToFillScreen * 2 + 2;
}
</script>

<template>
  <div class="w-full overflow-hidden">
    <div class="animate-marquee">
      <div
        v-for="i in itemCount"
        :key="i"
        ref="item_refs"
        :aria-hidden="i !== 1 || undefined"
        class="marquee-item h-min select-none"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
.marquee-item {
  padding-right: var(--marquee-gap, min(5vw, v-bind('DEFAULT_GAP')));
  font-size: min(calc((200 / 1728) * 100vw), 200px);
  letter-spacing: 0.125rem;
}

@media (max-width: 639px) {
  .marquee-item {
    font-size: 96px;
  }
}

.animate-marquee {
  display: flex;
  width: max-content;
  will-change: transform;
  animation-name: marquee;
  animation-duration: var(--marquee-speed, calc(v-bind('itemCount') / 4 * 10s));
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: var(--marquee-direction, reverse);
}

@keyframes marquee {
  to {
    transform: translateX(-50%);
  }
}
</style>
